import { CEUserBase } from './ce-user-base'


export class CEUser extends CEUserBase {

}